import { Divider, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import { useLocation } from "react-router-dom";
import PdfPreview from "../../OMR/ViewOMR/PdfPreview";
// import ScoreImage from "../../images/scoreimage.png";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "75%",
    margin: "3rem auto",
    textAlign: "center",
    "& .MuiTypography-caption": {
      fontFamily: "Jost",
      fontSize: "1.2rem",
      fontWeight: "500",
      color: "#223852",
    },
    "& .MuiTypography-h6": {
      fontFamily: "Jost",
      fontSize: "1.5rem",
      fontWeight: "700",
      color: "#223852",
    },
  },
  imageContainer: {},
  yourScore: {
    margin: "2rem auto",
    background: "#E7E7E799",
    width: "15%",
    padding: "0.3rem 2rem",
    borderRadius: "6px",
  },
  incorrectCorrectTime: {
    display: "flex",
    justifyContent: "center",
    margin: "2rem 0",
  },
  divider: {
    margin: "0 3rem",
  },
  uploadedPdfBox:{
// border:'1px solid black',
display:'flex',
justifyContent:'center',
alignItems:'center',
width:'100%',
scrollbarWidth: "none",

},
}));

function FinalScore({ examResultData }) {

  const classes = useStyles();
  console.log("examResultData----------------------", examResultData)

  return (

      <div className={`${classes.uploadedPdfBox}`} style={{ padding: "15px" }}>
        {examResultData.photo_url.match(/\.(jpeg|jpg|png|gif)$/i) ? (
          <div className={classes.relativePostition} style={{ width: "76%" }}>
            {/* <div className={classes.fontsize1}><span style={{ fontWeight: 600 }}>Roll Number:</span> {examResultData.roll_number}</div> */}
            <img
              src={examResultData.photo_url}
              alt={`Uploaded file`}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "4px",
                border: "1px solid lightgrey",
              }}
              onError={(e) => console.error("Error loading image:", examResultData.photo_url)}
            />
          </div>
        ) : examResultData.photo_url.match(/\.pdf$/i) ? (
          <PdfPreview
            file={examResultData.photo_url}
            handleRemoveFile={() => { }} // No remove option for photo_url
          />
        ) : null}
      </div>
  );
}

export default FinalScore;
